import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { ICommandGroupMap } from '../../interfaces/dtos/ICommandsGroup';

export interface ICommandMenuState {
  rawCommands: ICommandGroupMap;
}

const initialState: ICommandMenuState = {
  rawCommands: {},
};

class CommandMenuReducer extends ImmerReducer<ICommandMenuState> {
  public setCommands(commands: ICommandGroupMap): void {
    this.draftState.rawCommands = commands;
  }
}

export const CommandMenuActions = createActionCreators(CommandMenuReducer);
export const CommandMenuReducerFunction = createReducerFunction(CommandMenuReducer, initialState);
